export default __webpack_public_path__ + "static/4-1ac423ec582a0a97c9acba7c3149ae81.jpeg";